<template>
	<el-select v-model="Value" placeholder="请选择" value-key="id">
        <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
    </el-select>
</template>
<script>
export default {
  name: 'agent-product-selector',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getOptions () {
      let params = {
        type: 'AGENT',
        businessType: ['ADULT'],
        pageableParam: { page: 0, size: 9999, sort: ['createdDate,asc'] }
      }
      let options = []
      this.$store.dispatch('getBranchCompanyList', params).then(res => {
        res.data.forEach(ele => {
          let obj = {
            label: ele.fullName,
            value: ele.id
          }
          options.push(obj)
        })
        this.options = options
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
